import { WhbabtecEnvironment } from '@whbabtec-types';

export const WHBABTEC_ENVIRONMENT: WhbabtecEnvironment = {
  production: true,
  env: 'prod',
  applicationUrl: 'https://customer-complaint.wh.com',
  api: {
    baseUrl: 'https://partnernet-backend.wh.com',
  },
  auth: {
    clientId: '2c370075-77d0-474e-9d9c-baf7a3623e87',
    scopes: ['offline_access', 'openid', 'profile', 'email', 'User.Read'],
    issuers: [
      'https://da426568-c872-45e8-b7ae-6f81ef0ff18e.ciamlogin.com/da426568-c872-45e8-b7ae-6f81ef0ff18e/v2.0',
      'https://login.microsoftonline.com/da426568-c872-45e8-b7ae-6f81ef0ff18e/v2.0',
    ],
  },
};
